/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Prep_AheadInputs */

const en_recipe_prep_ahead = /** @type {(inputs: Recipe_Prep_AheadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prep the day before`)
};

const de_recipe_prep_ahead = /** @type {(inputs: Recipe_Prep_AheadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Vortag vorbereiten`)
};

/**
* | output |
* | --- |
* | "Prep the day before" |
*
* @param {Recipe_Prep_AheadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_prep_ahead = /** @type {((inputs?: Recipe_Prep_AheadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Prep_AheadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_prep_ahead(inputs)
	return en_recipe_prep_ahead(inputs)
});